(function () {
    'use strict';

    angular
        .module('franchisee-portal.services')
        .service('MeService', MeService)

    /** @ngInject */
    function MeService($httpParamSerializerJQLike, $http, HttpService, ROUTES) {
        const MeService = {
            getMe,
            refreshToken
        }

        return MeService;

        function getMe() {
            return HttpService.get('/people/me');
        }

        function refreshToken(refreshToken, tokenOwner) {
            const loginData = {
                refresh_token: refreshToken,
                grant_type: 'refresh_token',
                client_id: tokenOwner
            };

            return $http.post(
                `${ROUTES.CENTRAL_CONTAS}api/authorization`,
                $httpParamSerializerJQLike(loginData),
                {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                }
            );
        }
    }
}());